<template>
  <div
    class="m-wrap-new m-pc"
    :style="{
      background:
        extras1.formBg.colorOrBg == 'color'
          ? extras1.formBg.color
          : 'url(' + extras1.formBg.src + ')',
    }"
  >
    <div class="semianr-logo" v-if="extras1 && extras1.formLogo.display == '1'">
      <img
        :src="
          isSetting != '1'
            ? extras1.headerLogo && extras1.headerLogo.src
            : './images/logo_new.png'
        "
        alt=""
      />
    </div>
    <div class="seminar-info" v-if="isSetting != '1'">
      <div
        class="seminar-info-new"
        v-if="extras1 && extras1.textSetting.display == '1'"
        :class="extras1.BannerText.textAlign"
      >
        <div class="content">
          <div
            v-if="extras1.textSetting.subTitle !== 'hide'"
            class="seminar-title"
            :style="{
              color:
                extras1.textSetting.subTitle == 'custom'
                  ? extras1.textSetting.subTitleFontColor
                  : '',
              'font-size':
                extras1.textSetting.subTitle == 'custom'
                  ? extras1.textSetting.subTitleFontSize + 'px'
                  : '',
              'font-weight':
                extras1.textSetting.subTitle == 'custom'
                  ? extras1.textSetting.subTitleFontWeight == 'on'
                    ? '900'
                    : ''
                  : '',
              'font-style':
                extras1.textSetting.subTitle == 'custom'
                  ? extras1.textSetting.subTitleFontTilt == 'on'
                    ? 'italic'
                    : 'normal'
                  : '',
            }"
          >
            {{ getSubTitleText() }}
          </div>
          <div
            v-if="extras1.textSetting.title !== 'hide'"
            class="seminar-slogan"
            :style="{
              color:
                extras1.textSetting.title == 'custom'
                  ? extras1.textSetting.titleFontColor
                  : '',
              'font-size':
                extras1.textSetting.title == 'custom'
                  ? extras1.textSetting.titleFontSize + 'px'
                  : '',
              'font-weight':
                extras1.textSetting.title == 'custom'
                  ? extras1.textSetting.titleFontWeight == 'on'
                    ? '900'
                    : ''
                  : '',
              'font-style':
                extras1.textSetting.title == 'custom'
                  ? extras1.textSetting.titleFontTilt == 'on'
                    ? 'italic'
                    : 'normal'
                  : '',
            }"
          >
            {{ getTitleText() }}
          </div>
          <div class="semianr-time">
            <div
              v-if="extras1.textSetting.timeTitle !== 'hide'"
              class="_title"
              :style="{
                color:
                  extras1.textSetting.timeTitle == 'custom'
                    ? extras1.textSetting.timeTitleFontColor
                    : '',
                'font-size':
                  extras1.textSetting.timeTitle == 'custom'
                    ? extras1.textSetting.timeTitleFontSize + 'px'
                    : '',
                'font-weight':
                  extras1.textSetting.timeTitle == 'custom'
                    ? extras1.textSetting.timeTitleFontWeight == 'on'
                      ? 'bolder'
                      : ''
                    : '',
                'font-style':
                  extras1.textSetting.timeTitle == 'custom'
                    ? extras1.textSetting.timeTitleFontTilt == 'on'
                      ? 'italic'
                      : 'normal'
                    : '',
                'background-color':
                  extras1.textSetting && extras1.textSetting.titleBgColor
                    ? extras1.textSetting.titleBgColor
                    : 'transparent',
              }"
            >
              {{ getTimeTitleText() }}
            </div>
            <div
              v-if="extras1.textSetting.time !== 'hide'"
              class="_time"
              :style="{
                color:
                  extras1.textSetting.time == 'custom'
                    ? extras1.textSetting.timeFontColor
                    : '',
                'font-size':
                  extras1.textSetting.time == 'custom'
                    ? extras1.textSetting.timeFontSize + 'px'
                    : '',
                'font-weight':
                  extras1.textSetting.time == 'custom'
                    ? extras1.textSetting.timeFontWeight == 'on'
                      ? 'bolder'
                      : ''
                    : '',
                'font-style':
                  extras1.textSetting.time == 'custom'
                    ? extras1.textSetting.timeFontTilt == 'on'
                      ? 'italic'
                      : 'normal'
                    : '',
                'background-color':
                  extras1.textSetting && extras1.textSetting.timeBgColor
                    ? extras1.textSetting.timeBgColor
                    : 'transparent',
              }"
            >
              {{ getTimeText() }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="seminar-info" v-if="isSetting == '1'">
      <div
        class="seminar-info-new"
        v-if="extras1 && extras1.textSetting.display == '1'"
      >
        <div class="content">
          <div
            v-if="extras1.textSetting.subTitle !== 'hide'"
            class="seminar-title"
            :style="{
              color:
                extras1.textSetting.subTitle == 'custom'
                  ? extras1.textSetting.subTitleFontColor
                  : '',
              'font-size':
                extras1.textSetting.subTitle == 'custom'
                  ? extras1.textSetting.subTitleFontSize + 'px'
                  : '',
              'font-weight':
                extras1.textSetting.subTitle == 'custom'
                  ? extras1.textSetting.subTitleFontWeight == 'on'
                    ? '900'
                    : ''
                  : '',
              'font-style':
                extras1.textSetting.subTitle == 'custom'
                  ? extras1.textSetting.subTitleFontTilt == 'on'
                    ? 'italic'
                    : 'normal'
                  : '',
            }"
          >
            2023企业数字化峰会
          </div>
          <div
            v-if="extras1.textSetting.title !== 'hide'"
            class="seminar-slogan"
            :style="{
              color:
                extras1.textSetting.title == 'custom'
                  ? extras1.textSetting.titleFontColor
                  : '',
              'font-size':
                extras1.textSetting.title == 'custom'
                  ? extras1.textSetting.titleFontSize + 'px'
                  : '',
              'font-weight':
                extras1.textSetting.title == 'custom'
                  ? extras1.textSetting.titleFontWeight == 'on'
                    ? '900'
                    : ''
                  : '',
              'font-style':
                extras1.textSetting.title == 'custom'
                  ? extras1.textSetting.titleFontTilt == 'on'
                    ? 'italic'
                    : 'normal'
                  : '',
            }"
          >
            设计连接 新商业
          </div>
          <div class="semianr-time">
            <div
              v-if="extras1.textSetting.timeTitle !== 'hide'"
              class="_title"
              :style="{
                color:
                  extras1.textSetting.timeTitle == 'custom'
                    ? extras1.textSetting.timeTitleFontColor
                    : '',
                'font-size':
                  extras1.textSetting.timeTitle == 'custom'
                    ? extras1.textSetting.timeTitleFontSize + 'px'
                    : '',
                'font-weight':
                  extras1.textSetting.timeTitle == 'custom'
                    ? extras1.textSetting.timeTitleFontWeight == 'on'
                      ? 'bolder'
                      : ''
                    : '',
                'font-style':
                  extras1.textSetting.timeTitle == 'custom'
                    ? extras1.textSetting.timeTitleFontTilt == 'on'
                      ? 'italic'
                      : 'normal'
                    : '',
                'background-color':
                  extras1.textSetting && extras1.textSetting.titleBgColor
                    ? extras1.textSetting.titleBgColor
                    : 'transparent',
              }"
            >
              {{ $t("success.meetingTime") }}
            </div>
            <div
              v-if="extras1.textSetting.time !== 'hide'"
              class="_time"
              :style="{
                color:
                  extras1.textSetting.time == 'custom'
                    ? extras1.textSetting.timeFontColor
                    : '',
                'font-size':
                  extras1.textSetting.time == 'custom'
                    ? extras1.textSetting.timeFontSize + 'px'
                    : '',
                'font-weight':
                  extras1.textSetting.time == 'custom'
                    ? extras1.textSetting.timeFontWeight == 'on'
                      ? 'bolder'
                      : ''
                    : '',
                'font-style':
                  extras1.textSetting.time == 'custom'
                    ? extras1.textSetting.timeFontTilt == 'on'
                      ? 'italic'
                      : 'normal'
                    : '',
                'background-color':
                  extras1.textSetting && extras1.textSetting.timeBgColor
                    ? extras1.textSetting.timeBgColor
                    : 'transparent',
              }"
            >
              {{ "2023.12.12-12.13" }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="field-area success"
      :style="{
        background:
          extras1.formFieldBg.colorOrBg == 'color'
            ? extras1.formFieldBg.color
            : 'url(\'' + extras1.formFieldBg.src.replace(/'/g, '\\\'') + '\')',
      }"
    >
      <SuccessCon
        :platform="platform"
        v-if="!signSuccess && (isRefuse == '0' || isRefuse == null)"
      />

      <!--审核未通过-->
      <RefuseCon
        :platform="platform"
        v-if="!signSuccess && isRefuse != '0' && isRefuse != null"
      />

      <!--报名成功-->
      <SuccessPartCon
        :platform="platform"
        :category="category"
        v-if="signSuccess"
      />
    </div>
  </div>
</template>

<script>
import SuccessCon from "@/components/SuccessConNew.vue";
import SuccessPartCon from "@/components/SuccessPartConNew.vue";
import RefuseCon from "@/components/RefuseConNew.vue";

import mixinConfig from "../../mixin/configNew.js";
import mixinMeeting from "../../mixin/meetingNew.js";
import mixinSuccess from "../../mixin/success.js";
export default {
  name: "PcSuccess",
  mixins: [mixinConfig, mixinMeeting, mixinSuccess],
  components: {
    SuccessCon,
    SuccessPartCon,
    RefuseCon,
  },
  computed: {
    extras1() {
      return this.$store.state.extras;
    },
  },
  data() {
    return {
      platform: "pc",
      visible: false,
      category: "",
    };
  },
  methods: {
    showModal() {
      this.visible = true;
    },
    handleOk() {
      this.visible = false;
    },
    getSubTitleText() {
      const config = this.extras1.textSetting;
      return config.subTitleText ? config.subTitleText : "2023企业数字化峰会";
    },
    getTitleText() {
      const config = this.extras1.textSetting;
      return config.titleText
        ? config.titleText
        : this.seminarInfo.title || "设计连接 新商业";
    },
    getTimeTitleText() {
      const config = this.extras1.textSetting;
      return (
        config.timeTitleText || config.text3 || this.$t("success.meetingTime")
      );
    },
    getTimeText() {
      const config = this.extras1.textSetting;
      return config.timeText
        ? config.timeText
        : this.handleTimeStamps(
            this.seminarInfo.startTime,
            this.seminarInfo.endTime
          );
    },
  },
};
</script>
